module.exports = __webpack_public_path__ + "img/language.b0ff34c.png";